import React, { Component, lazy, Suspense } from "react";
import { ThemeProvider } from "styled-components";
import initApm from "@elastic/apm-rum";
import lightTheme from "../../styles/themes/light";
import config from "../../core/config.js";
import { Redirect, Route, withRouter } from "react-router-dom";
import { Switch } from "react-router";
import { withTracker } from "../components/withTracker";
import "../app/App.scss";
import { Toast } from "biologiatotal-ui";
import Home from "../../home";
import { router as AccountRoute } from "../account";
import TermsOfUse from "../termsOfUse";

const App = lazy(() => import("../app/App"));

const MyEssayDetailsRouter = lazy(() => import("../users/components/essayFeedback/myEssayDetailsExterno"));
const MyEssayDetails = props => <MyEssayDetailsRouter {...props} />;

const AppRoute = props => <App {...props} />;

class Root extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.location.pathname !== this.props.location.pathname;
  }

  componentDidMount() {
    initApm({
      serviceName: process.env.REACT_APP_ELASTIC_APM_SERVICE_NAME,
      serverUrl: process.env.REACT_APP_ELASTIC_APM_SERVER_URL,
      environment: process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT
    });
  }

  render() {
    return (
      <div style={{ display: "flex" }} className="App">
        <ThemeProvider theme={lightTheme}>
          <Suspense fallback={<div />}>
            <Switch>
              <Route exact={true} path="/management/correcao/externo/:id" component={MyEssayDetails} />
              <Route path="/management/termos-de-uso/:id" component={TermsOfUse} />
              <Route path="/management/login" component={AccountRoute} />
              <Route path="/management" component={AppRoute} />
              <Redirect to={"/management/login"} />
            </Switch>
          </Suspense>
          <Toast.box />
        </ThemeProvider>
      </div>
    );
  }
}

const trackedRoot = config.env === "production" ? withTracker(Root) : Root;

export default withRouter(trackedRoot);
